import { useEffect, useState } from "react";

const MOBILE_QUERY = "(max-width: 640px)";
const TABLET_QUERY = "(max-width: 1024px)";

const useMediaMatcher = (query: string) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [matches, query]);

  return matches;
};

const useBreakpoint = () => {
  const isMobile = useMediaMatcher(MOBILE_QUERY);
  const isTablet = useMediaMatcher(TABLET_QUERY);
  const isDesktop = !isMobile && !isTablet;

  return { isMobile, isTablet, isDesktop };
};

export { useBreakpoint };
